module.exports = __webpack_public_path__ + "img/header_background.dcb032d1.png";